const prefix = "app/ReportsV2/ReportAmbassador"

export const GET_STATUS_WATCHER = `${prefix}/GET_STATUS_WATCHER`
export const GET_STATUS_SUCCESS = `${prefix}/GET_STATUS_SUCCESS`
export const GET_STATUS_FAILED = `${prefix}/GET_STATUS_FAILED`

export const GET_MEASURE_COLOR_RANGE_WATCHER = `${prefix}/GET_MEASURE_COLOR_RANGE_WATCHER`
export const GET_MEASURE_COLOR_RANGE_SUCCESS = `${prefix}/GET_MEASURE_COLOR_RANGE_SUCCESS`
export const GET_MEASURE_COLOR_RANGE_FAILED = `${prefix}/GET_MEASURE_COLOR_RANGE_FAILED`

export const GET_MEASURE_TOTAL_WATCHER = `${prefix}/GET_MEASURE_TOTAL_WATCHER`
export const GET_MEASURE_TOTAL_SUCCESS = `${prefix}/GET_MEASURE_TOTAL_SUCCESS`
export const GET_MEASURE_TOTAL_FAILED = `${prefix}/GET_MEASURE_TOTAL_FAILED`

export const GET_MEASURE_TOTAL_SUB_DIVISION_WATCHER = `${prefix}/GET_MEASURE_TOTAL_SUB_DIVISION_WATCHER`
export const GET_MEASURE_TOTAL_SUB_DIVISION_SUCCESS = `${prefix}/GET_MEASURE_TOTAL_SUB_DIVISION_SUCCESS`
export const GET_MEASURE_TOTAL_SUB_DIVISION_FAILED = `${prefix}/GET_MEASURE_TOTAL_SUB_DIVISION_FAILED`

export const GET_MEASURE_INFO_WATCHER = `${prefix}/GET_MEASURE_INFO_WATCHER`
export const GET_MEASURE_INFO_SUCCESS = `${prefix}/GET_MEASURE_INFO_SUCCESS`
export const GET_MEASURE_INFO_FAILED = `${prefix}/GET_MEASURE_INFO_FAILED`
